/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import bgImage from "../../../src/Assets/Mask group.png";
// import boxLine from "../../Assets/NewList/box-line.png";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import soldout from "../../Assets/soldout.png";
import Button from "../Button/Button";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  calculateEarning,
  checkTransactionLimit,
  ClientConfigurationData,
  ClientInfo,
  formatPrice,
  getRewardBaseDenomination,
  GetProdBudSumData,
  handleLimit,
  MaxQuan,
  showMaxMessg,
  SupplierCapping,
  TransactionLimit,
  useEarnRoiCalculationContext,
  useClientConfigFlag,
  V3Data,
  LoginV3Data,
  getImageUrl,
} from "../Utility/Utility";
import { setProduct } from "../../Store/Slices/productDataSlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import { encryptURLParam } from "../../Common/Axios/encrypt";
import pointIcon from "../../Assets/point_icon.svg";
import defaultImage from "../../Assets/fallbackimg_giftcard.png";
import ReedemType from "../Card/RedeemType";
import ProductAttributes from "../ProductAttributes/ProductAttributes";
import {
  onPostAddToCart,
  onPostAddToCartReset,
} from "../../Store/Slices/addToCartSlice";
const isEnabledConfigValue = (value) =>
  value === true ||
  value === 1 ||
  ["1", "true", "active"].includes(
    String(value ?? "")
      .trim()
      .toLowerCase(),
  );

const EarnPointsModal = ({
  show,
  handleClose,
  modalDataValue,
  modalClass,
  products,
}) => {
  const translation = getTranslationData();
  const navigate = useNavigate();
  const loginV3Data = LoginV3Data();
  const [moduleData, setModuleData] = useState([]);
  const isLogin = sessionStorage.getItem("login");
  const v3Data = V3Data();
  const transactionLimit = TransactionLimit();
  const AddToCartResponse = useSelector((state) => state.addToCartReducer);
  let priceDenominations = [];
  const priceData = modalDataValue?.clientProductDenomination;
  const enabledPriceData = Array.isArray(priceData)
    ? priceData.filter((item) => item?.enabled === true)
    : [];

  const dispatch = useDispatch();
  const conBudSumData = GetProdBudSumData();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const prodSumData = conBudSumData?.getCustomerProduct?.filter(
    (filterdata) =>
      filterdata?.productIdentifier === String(modalDataValue?.id),
  );

  if (Array.isArray(priceData)) {
    priceDenominations = enabledPriceData.map((item) => item?.denomination);
  } else {
    priceDenominations = [];
  }
  useEffect(() => {
    if (Array.isArray(priceData)) {
      setStockOutDenominations(
        enabledPriceData.length > 0 &&
          enabledPriceData.every((item) => item?.stockOut === true),
      );
      setOutOfStockLabel(enabledPriceData.map((item) => item?.stockOut));
    }
  }, [priceData]);
  const [quantity, setQuantity] = useState(
    priceDenominations?.map((_, index) => (index === 0 ? 0 : 0)),
  );

  const [finalAmount, setFinalAmount] = useState(0);

  const discount = modalDataValue?.customerDiscount;
  const supplierCapping = SupplierCapping();
  const maxQuan = MaxQuan();
  const totalDenominationAmount = priceDenominations?.reduce(
    (acc, price, index) =>
      acc + Number(price || 0) * Number(quantity[index] || 0),
    0,
  );
  const totalDenominationAfterDiscountAmount =
    totalDenominationAmount -
    (totalDenominationAmount * Number(discount || 0)) / 100;
  const convenienceFeeAmount =
    (totalDenominationAfterDiscountAmount *
      Number(modalDataValue?.convenienceFee || 0)) /
    100;
  const gstAmount =
    (convenienceFeeAmount * Number(modalDataValue?.gst || 0)) / 100;
  const payableAmount =
    totalDenominationAfterDiscountAmount + convenienceFeeAmount + gstAmount;

  const { isTransactionLimitExceeded } = checkTransactionLimit({
    transactionAmountType: transactionLimit?.transactionAmountType,
    totalAmountCapping: transactionLimit?.totalAmountCapping,
    totalDenominationAmount,
    totalDenominationAfterDiscountAmount,
    payableAmount,
  });

  useEffect(() => {
    const newFinalAmount = priceDenominations?.reduce((acc, price, index) => {
      return acc + price * quantity[index];
    }, 0);
    setFinalAmount(newFinalAmount);
    // priceDenominations is rebuilt every render but derives only from priceData,
    // so key on priceData to avoid re-running this effect after every render.
  }, [quantity, priceData]);

  const handleIncrease = (index, item) => {
    setQuantity((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      const nextValue = newQuantities[index] + 1;
      newQuantities[index] = nextValue;

      const projectedTotalDenominationAmount = priceDenominations?.reduce(
        (acc, price, idx) =>
          acc + Number(price || 0) * Number(newQuantities[idx] || 0),
        0,
      );
      const projectedTotalAfterDiscountAmount =
        projectedTotalDenominationAmount -
        (projectedTotalDenominationAmount * Number(discount || 0)) / 100;
      const projectedConvenienceFeeAmount =
        (projectedTotalAfterDiscountAmount *
          Number(modalDataValue?.convenienceFee || 0)) /
        100;
      const projectedGstAmount =
        (projectedConvenienceFeeAmount * Number(modalDataValue?.gst || 0)) /
        100;
      const projectedPayableAmount =
        projectedTotalAfterDiscountAmount +
        projectedConvenienceFeeAmount +
        projectedGstAmount;

      const {
        isTransactionLimitExceeded: isProjectedTransactionLimitExceeded,
      } = checkTransactionLimit({
        transactionAmountType: transactionLimit?.transactionAmountType,
        totalAmountCapping: transactionLimit?.totalAmountCapping,
        totalDenominationAmount: projectedTotalDenominationAmount,
        totalDenominationAfterDiscountAmount: projectedTotalAfterDiscountAmount,
        payableAmount: projectedPayableAmount,
      });

      if (isProjectedTransactionLimitExceeded) {
        toast.error(translation?.transaction_limit_exceed);
        return prevQuantities;
      }

      if (nextValue === supplierCapping) {
        showMaxMessg(translation.max_capping_allowed, supplierCapping, 1, item);
      }

      return newQuantities;
    });
  };

  const handleDecrease = (index) => {
    setQuantity((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] = Math.max(newQuantities[index] - 1, 0);
      return newQuantities;
    });
  };

  useEffect(() => {
    const newArrayData = priceDenominations
      ?.map((item, index) => ({
        denomination: item,
        you_pay: item - (item * discount) / 100,
        saving: (item * discount) / 100,
        quantity: quantity[index],
      }))
      .filter((obj) => obj.quantity > 0);

    setModuleData(newArrayData);
  }, [quantity, discount]);

  function calculateTotalQuantity(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  const buildAddToCartPayload = () => ({
    memberId: loginV3Data?.memberIdentifier || "",
    items: [
      {
        productId: Number(modalDataValue?.id || 0),
        sku: modalDataValue?.sku || "",
        name: modalDataValue?.name || "",
        supplierCode: modalDataValue?.supplierCode || "asdfg",
        productImage: getImageUrl(modalDataValue?.small) || defaultImage,

        createdAt: modalDataValue?.createdAt || new Date().toISOString(),

        updatedAt: modalDataValue?.updatedAt || new Date().toISOString(),

        productDetails: moduleData.map((item) => ({
          denomination: Number(item?.denomination || 0),
          qty: Number(item?.quantity || 0),
          addedAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        })),
      },
    ],
  });
  const handleClick = () => {
    const totalQuantity = calculateTotalQuantity(moduleData);

    // Existing validation
    if (totalQuantity === 0) {
      toast.error(translation?.pleaseAddTheProduct);
      return;
    }

    // Existing max quantity validation
    if (totalQuantity > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
      return;
    }

    // Existing transaction limit validation
    if (isTransactionLimitExceeded) {
      toast.error(translation?.transaction_limit_exceed);
      return;
    }

    if (finalAmount <= 0) {
      toast.error(translation?.pleaseAddTheProduct);
      return;
    }

    // build Add To Cart payload
    const payload = buildAddToCartPayload();
    if (!isLogin) {
      const productIdValue = modalDataValue?.id?.toString();

      const finalProductId =
        process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? productIdValue
          : encryptURLParam(productIdValue);

      const pathName = window.location.pathname;
      const search = window.location.search;

      // Existing functionality
      localStorage.setItem(
        "ProductListPage",
        `/card?productId=${finalProductId}`,
      );

      localStorage.setItem("ProductListPage_back", pathName + search);

      // Existing module data
      sessionStorage.setItem("arrayData", JSON.stringify(moduleData));

      // Save Add To Cart payload for after login
      sessionStorage.setItem(
        "pendingAddToCartPayload",
        JSON.stringify(payload),
      );

      sessionStorage.setItem("pendingAddToCartReturnPath", pathName + search);

      // Existing login redirect
      window.location.href = v3Data?.SignInUrl;

      return;
    }
    dispatch(onPostAddToCart(payload));
  };

  useEffect(() => {
    if (AddToCartResponse?.post_status_code === "200") {
      const productIdValue = modalDataValue?.id?.toString();

      if (!productIdValue) {
        return;
      }

      const finalProductId =
        process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? productIdValue
          : encryptURLParam(productIdValue);

      // Remove pending payload after successful Add To Cart
      sessionStorage.removeItem("pendingAddToCartPayload");
      sessionStorage.removeItem("pendingAddToCartReturnPath");

      dispatch(onPostAddToCartReset());

      navigate(`/card?productId=${finalProductId}`, {
        state: { moduleData },
      });
    } else if (
      ["400", "401", "500"].includes(AddToCartResponse?.post_status_code)
    ) {
      toast.error(
        AddToCartResponse?.postMessage || "Unable to add product to cart",
      );
      dispatch(onPostAddToCartReset());
    }
  }, [AddToCartResponse?.post_status_code]);
  const rewardProduct =
    products?.find(
      (entry) => String(entry?.id) === String(modalDataValue?.id),
    ) || modalDataValue;
  const rewardMinEarn = rewardProduct?.minEarnPoints || 0;
  const rewardMinBurn = rewardProduct?.maxEarnPoints || 0;

  const clientinfo = ClientInfo();
  const earnRoiCalculationContext = useEarnRoiCalculationContext();
  const clientConfigurationData = ClientConfigurationData();
  const clientConfigReducer = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0],
  );
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview",
  )?.configValue;
  const isEarn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearn",
  )?.configValue;
  const earnLabelConfig =
    clientConfigurationData?.clientConfig?.find(
      (item) =>
        String(item?.configKey ?? "")
          .trim()
          .toLowerCase() === "isearnlabelshowonly",
    )?.configValue ??
    clientConfigurationData?.isEarnLabelShowOnly ??
    clientConfigurations?.find(
      (item) =>
        String(item?.configKey ?? "")
          .trim()
          .toLowerCase() === "isearnlabelshowonly",
    )?.configValue;
  const discountShowLabelConfig =
    clientConfigReducer?.clientConfig?.find(
      (item) =>
        String(item?.configKey ?? "")
          .trim()
          .toLowerCase() === "isdiscountlabeldisplay",
    )?.configValue ?? clientConfigReducer?.isDiscountLabelDisplay;
  const journeyType = clientinfo?.clientData?.journeyType;
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const chooseDenominationLabel = !isWalletJourney
    ? translation?.luxuryChooseYourDenomination?.replace("{maxQuan}", maxQuan)
    : translation?.chooseYourDenomination
      ? `${translation.chooseYourDenomination} (up to ${maxQuan})`
      : null;
  const useEarnLabelOnly =
    isEnabledConfigValue(earnLabelConfig) && !isWalletJourney;
  const isDiscountShowLabelConfig = isEnabledConfigValue(
    discountShowLabelConfig,
  );
  const isProductAttributeGridEnabled = useClientConfigFlag(
    "isProductAttributeGridDisplay",
  );
  const rewardBaseDenomination = getRewardBaseDenomination({
    product: rewardProduct,
    // Conversion uses the configured minimum, even when it is disabled for purchase.
    eligibleDenominations: priceData,
    fallbackDenominations: priceData,
  });
  const calculateEarnData = (amount) =>
    calculateEarning({
      ...earnRoiCalculationContext,
      amount,
      minEarnPoints: rewardMinEarn,
      minBurnPoints: rewardMinBurn,
      baseDenomination: rewardBaseDenomination,
      discountPercentage: discount,
    });
  const hasEarnConfiguration =
    Number(rewardMinEarn) > 0 && isEarn !== "2" && isEarnView !== "2";
  const showEarnLabelOnly = useEarnLabelOnly && hasEarnConfiguration;
  useEffect(() => {
    handleLimit(
      finalAmount,
      prodSumData,
      dispatch,
      translation,
      modalDataValue?.productBudget?.limits,
    );
  }, [finalAmount]);

  return (
    <div className="modal_Quick">
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="exampleModalLabel"
        centered
        className={`earn-points-modal ${modalClass}`}
      >
        <ToastContainer />
        <Modal.Body>
          <div
            id="amazon_gift_card"
            className="body position-relative-QuickModal modal-content-scrollable1"
          >
            {/* Fixed Header */}
            <div className="d-flex justify-content-between align-items-center fixed-top bg-white card_h_padding">
              <div className="modal_header_box">
                <div className="popup-header mb-5-px">
                  <h5 className="heading mb-0">{modalDataValue.name}</h5>
                  <span
                    className="modal-cross"
                    role="button"
                    onClick={handleClose}
                  >
                    <i className="fa-solid fa-xmark xmark_FS"></i>
                  </span>
                </div>
                <div className="sub_header_discountview">
                  {modalDataValue?.customerDiscount !== 0 && (
                    <span
                      className={` ${isDiscountShowLabelConfig ? "pro-discount1  pro-discount-modal" : "d-none pro-discount1  pro-discount-modal"}`}
                    >
                      {translation.discount_flat}{" "}
                      {modalDataValue?.customerDiscount}%
                    </span>
                  )}
                  {isProductAttributeGridEnabled ? (
                    <ProductAttributes
                      redeemableType={modalDataValue?.redeemableType || ""}
                      validity={modalDataValue?.validity}
                      productBudget={modalDataValue?.productBudget}
                      productId={modalDataValue?.id}
                    />
                  ) : (
                    <>
                      <ReedemType
                        status={modalDataValue?.redeemableType || ""}
                      />
                      <ProductAttributes
                        validity={modalDataValue?.validity}
                        include={["validity"]}
                      />
                    </>
                  )}
                </div>
                {stockOutDenominations ? (
                  <div className="mod-head redeem-padd mt-3">
                    <h5 className="heading1 mb-0">
                      {translation.AvailabilityOfDenominations}
                    </h5>
                  </div>
                ) : (
                  <div className="mod-head">
                    <h5 className="heading1 mb-0">
                      {/* {modalDataValue.name.length > 30
                      ? modalDataValue.name.substring(0, 30) + "..."
                      : modalDataValue.name} */}
                      {maxQuan !== 0 && chooseDenominationLabel}
                    </h5>
                  </div>
                )}
              </div>
            </div>
            {/* Scrollable Content */}
            <div className="modal-content-scrollable mb-1">
              {stockOutDenominations && (
                <div className="redemption_soldOutBox text-center mt-2 mb-4">
                  <div className="stockout-image ">
                    <img src={soldout} alt="Sold Out" className="mb-1" />
                    <p className="stockout-text ">{translation?.stock_out}</p>
                    <p>{translation?.stockout_message_desc_all_denomination}</p>
                  </div>
                </div>
              )}

              {priceDenominations?.map((item, index) => (
                <div
                  className={`d-flex card_box_innerbox justify-content-between align-item-center mb-3 position_relatives ${
                    index === 0 ? "pt-2" : ""
                  }`}
                  key={index}
                >
                  {!stockOutDenominations && (
                    <>
                      <div
                        className={`d-flex modal_discount_price ${outOfStockLabel?.[index] ? "out_of_stock_box" : ""}`}
                      >
                        <div
                          className="amount-box"
                          // className="background_image"
                          // style={{ backgroundImage: `url(${bgImage})` }}
                        >
                          <div className="price_in_box rs_price">
                            <span className="currency">₹</span>
                            <span className="amount">{item}</span>
                          </div>

                          {/* <img alt="not-found" src={boxLine} /> */}
                        </div>
                        {!showEarnLabelOnly && (
                          <div className="font-blk col-lg-3 col-3">
                            <span className="padd-lft">
                              {modalDataValue?.customerDiscount !== 0 &&
                              item !== item - (item * discount) / 100 ? (
                                <>
                                  <strike
                                    className={`pro-mrp`}
                                    style={{ textDecoration: "line-through" }}
                                  >
                                    ₹{item}
                                  </strike>
                                </>
                              ) : (
                                ""
                              )}
                              <span className="actual-mrp">
                                ₹
                                {(() => {
                                  const value = item - (item * discount) / 100;
                                  const isWhole = value % 1 === 0;
                                  return value.toLocaleString(undefined, {
                                    minimumFractionDigits: isWhole ? 0 : 2,
                                    maximumFractionDigits: 2,
                                  });
                                })()}
                              </span>
                            </span>

                            {hasEarnConfiguration &&
                              (() => {
                                const denominationEarning =
                                  calculateEarnData(item);
                                if (denominationEarning.points <= 0)
                                  return null;

                                return (
                                  <div className="fa_star_border1 mt-2 quick-buy-standard-earn-label">
                                    <span className="fa_star_box">
                                      {translation?.earn}&nbsp;
                                      {denominationEarning.points.toLocaleString(
                                        "en-IN",
                                      )}{" "}
                                      {translation?.pts}
                                    </span>
                                  </div>
                                );
                              })()}
                          </div>
                        )}
                        {showEarnLabelOnly &&
                          (() => {
                            const denominationEarning = calculateEarnData(item);
                            if (denominationEarning.points <= 0) return null;

                            return (
                              <div className="pdp-denomination-reward-box quick-buy-denomination-reward-box">
                                <div className="pdp-denomination-earn">
                                  <span className="pdp-denomination-earn-content">
                                    <span className="pdp-denomination-earn-line">
                                      {translation?.earn}{" "}
                                      <img
                                        src={pointIcon}
                                        alt=""
                                        aria-hidden="true"
                                      />{" "}
                                      <b className="pdp-earned-points">
                                        {denominationEarning.points.toLocaleString(
                                          "en-IN",
                                        )}
                                      </b>
                                    </span>
                                    {denominationEarning.worth > 0 && (
                                      <span className="pdp-denomination-worth">
                                        {translation?.worth || "worth ₹"}
                                        {formatPrice(denominationEarning.worth)}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>
                            );
                          })()}
                      </div>

                      {outOfStockLabel?.[index] ? (
                        <div className="stockOutContent stockOutQuickBuy">
                          <div className="stockOut">
                            {translation?.out_of_stock}
                          </div>
                        </div>
                      ) : (
                        <div className="number modal-inc_dec_btn d-flex align-item-center col-2">
                          {quantity[index] > 0 && (
                            <>
                              <button
                                className="minus mp-b"
                                onClick={() => handleDecrease(index)}
                              >
                                −
                              </button>
                              <input
                                className="item-qnty mod-qnty"
                                type="text"
                                value={quantity[index]}
                                readOnly
                              />
                            </>
                          )}

                          <button
                            className={`plus mp-b ${
                              quantity[index] === supplierCapping
                                ? "quantity-disabled"
                                : ""
                            }`}
                            onClick={() => handleIncrease(index, item)}
                            disabled={
                              quantity[index] === supplierCapping ||
                              v3Data?.disable ||
                              isTransactionLimitExceeded
                            }
                          >
                            +
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="mod-pad1">
              {v3Data?.disable && (
                <PurchaseLimitAlertTile
                  timePeriod={v3Data?.timePeriod}
                  amount={v3Data?.amount}
                  reset_text={v3Data?.reset_text}
                  name={modalDataValue?.name}
                />
              )}

              <div>
                <Button
                  className="col-12 continue-btn mt-2 btn-sz font-black"
                  onClick={stockOutDenominations ? null : handleClick}
                  disabled={
                    v3Data.disable ||
                    stockOutDenominations ||
                    isTransactionLimitExceeded
                  }
                  text={
                    AddToCartResponse?.isPostLoading ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      translation.continue
                    )
                  }
                />

                {/* 
                <Button
                  onClick={handleClose}
                  text={translation.cancel}
                  className="cancel-link"
                /> */}
                <div className="redeem-padd info-box text-center">
                  <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span>
                  {translation?.redeemPointsCheckout}
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EarnPointsModal;
